/**
 * Return min ticket valid from date.
 * @param minValidFrom from system configuration
 */
export const getTicketMinValidFrom = (minValidFrom: 'TOMORROW' | 'TODAY'): Date => {
  const minDate = new Date();

  if (minValidFrom === 'TOMORROW') {
    minDate.setDate(minDate.getDate() + 1);
  }

  return minDate;
};
